// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "chunks-css-min/" + {"177":"home","182":"booking-scss","393":"about-scss","443":"about","461":"expertises","463":"contact-scss","475":"casestudies-scss","606":"home-scss","617":"pages-scss","756":"blog-scss","766":"expertises-scss","815":"seo-scss","982":"casestudies"}[chunkId] + ".css";
};